/**
 *
 * @param {string} phrase Sensitive to strings separated with either space or hyphen.
 * @returns The title case version of the phrase.
 */
const toTitleCase = (phrase: string): string =>
    phrase.toLowerCase().replace(/(?:^|[\s-])\w/g, (match) => match.toUpperCase());

export default toTitleCase;
